import BaseWidget from 'components/BaseWidget/BaseWidget';
import VMSWidget from './widgets/VMSWidget';

export default function VMSWidgetGateway({
  widgetType = 'cameras',
  dimensions,
  isLoading,
  widgetRuntime,
}) {
  return (
    <BaseWidget
      widgetType={widgetType}
      dimensions={dimensions}
      isLoading={isLoading}
      renderers={{
        cameras: () => <VMSWidget widgetRuntime={widgetRuntime} />,
      }}
    />
  );
}
